import { instance, APISDKFactory } from 'seismic-common';
import { HTTPSTATUS } from '../../commonUtil/constants';

const getAPIClient = (domain) => {
    const apiClient = {};
    const apiSDKFactory = instance.getService(APISDKFactory);
    Object.assign(apiClient, apiSDKFactory.create({
        apiService: fetch,
        domainResolver: () => domain,
        globalErrorHandlers: {
            404: (resend, resolve, reject, result) => {
                reject({ errorCode: HTTPSTATUS.NOT_FOUNT, ...result });
            },
            500: (resend, resolve, reject, result) => {
                reject({ errorCode: HTTPSTATUS.INTERNAL_SERVER_ERROR, ...result });
            }
        },
        /* eslint-disable global-require */
        schema: {
            engagement: {
                v1: require('./schema/viewer-v1.json')
            },
            bes: {
                v1: require('./schema/bes-v1.json'),
                v2: require('./schema/bes-v2.json')
            }
        }
    }));
    return apiClient;
};

export default getAPIClient;
